import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { ActionTextContentModel } from './action-text-content-model';

@Component({
  selector: 'pg-action-text-factory, grit-action-text-factory',
  templateUrl: './pg-action-text-factory.component.html',
  styleUrls: ['./pg-action-text-factory.component.scss'],
})
export class PgActionTextFactoryComponent extends UiFactory {
  @Input() model: any;
  @Input() parentFormGroup: FormGroup;

  get actionTextContentModel(): ActionTextContentModel {
    return this.model;
  }

  constructor(private _behaviorService: BehaviorService) {
    super(_behaviorService);
  }

  async handleActionClicked() {
    if (
      this.actionTextContentModel.onActionClick &&
      this.actionTextContentModel.onActionClick.length
    ) {
      await this._behaviorService.execute(
        this.actionTextContentModel.onActionClick,
        {
          target: this,
          targetModel: this.actionTextContentModel,
          formGroup: this.parentFormGroup,
        }
      );
    }
  }

  getSpinnerSize() {
    // TODO: add a spinner size field too

    return this.actionTextContentModel.fontSize || 16;
  }

  getSpinnerStrokeWidth() {
    return (this.actionTextContentModel.fontSize || 16) / 8;
  }

  getIconFontSize() {
    return Math.max(this.actionTextContentModel.fontSize, 16);
  }
}
